import React from "react";
import "./index.css";
import Board from "./components/Board/Board";

function App() {
  return (
    <div className="chess-app">
      <Board />
    </div>
  );
}

export default App;
